import {Langdict} from './langdict';
import {TokenType} from './token-type';

export class IRegistrationRound {
  name: Langdict;
  dateTo: Date;
  registrationId: string;
  microBreakLength: number;
  id: number;
  firstRoundCalibration: number;
  hasPriorities: boolean;
  isExchange: boolean;
  isDedicated: boolean;
  dateFrom: Date;
  isOnlyEntitled: boolean;
  tokens: TokenType[];
}

export class RegistrationRound extends IRegistrationRound {
  constructor(obj: IRegistrationRound) {
    super();
    this.name = new Langdict(obj.name);
    this.dateTo = new Date(obj.dateTo);
    this.registrationId = obj.registrationId;
    this.microBreakLength = obj.microBreakLength;
    this.id = obj.id;
    this.firstRoundCalibration = obj.firstRoundCalibration;
    this.hasPriorities = obj.hasPriorities;
    this.isExchange = obj.isExchange;
    this.isDedicated = obj.isDedicated;
    this.dateFrom = new Date(obj.dateFrom);
    this.isOnlyEntitled = obj.isOnlyEntitled;
    this.tokens = obj.tokens.map(t => new TokenType(t));
  }
}
